import { render, staticRenderFns } from "./WithdrawalAccount.vue?vue&type=template&id=35a80148&"
import script from "./WithdrawalAccount.vue?vue&type=script&lang=js&"
export * from "./WithdrawalAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports